import React from 'react'
import { Container, Row, Col, Image } from 'react-bootstrap'
import LineImg2 from '../../../Assets/images/DFL/landing-page-img/engagment-static-page-img/line_2.png'
import LineImg3 from '../../../Assets/images/DFL/landing-page-img/engagment-static-page-img/line_3.png'
import LeftArrow from '../../../Assets/images/DFL/landing-page-img/left-arrow.png'
import RightArrow from '../../../Assets/images/DFL/landing-page-img/right-arrow.png'



import Round from "../../../Assets/images/DFL/landing-page-img/engagment-static-page-img/shap-img/round.png";
import Princess from "../../../Assets/images/DFL/landing-page-img/engagment-static-page-img/shap-img/princess.png";
import Emerald from "../../../Assets/images/DFL/landing-page-img/engagment-static-page-img/shap-img/emerald.png";
import Oval from "../../../Assets/images/DFL/landing-page-img/engagment-static-page-img/shap-img/oval.png";
import Radiant from "../../../Assets/images/DFL/landing-page-img/engagment-static-page-img/shap-img/radiant.png";
import Asscher from "../../../Assets/images/DFL/landing-page-img/engagment-static-page-img/shap-img/asscher.png";
import Marquise from "../../../Assets/images/DFL/landing-page-img/engagment-static-page-img/shap-img/marquise.png";
import Heart from "../../../Assets/images/DFL/landing-page-img/engagment-static-page-img/shap-img/heart.png";
import Pear from "../../../Assets/images/DFL/landing-page-img/engagment-static-page-img/shap-img/pear.png";

import { LazyLoadImage } from "react-lazy-load-image-component";



import Slider from 'react-slick'
import { NavLink, useHistory } from 'react-router-dom'
const ShopByShap = () => {
    const history = useHistory

    const ringShopByStyle = {
        dots: false,
        infinite: true,
        speed: 500,
        prevArrow: <img src={LeftArrow} />,
        nextArrow: <img src={RightArrow} />,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 992,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    const settingsShopByShape = {
        dots: false,
        infinite: true,
        speed: 500,
        prevArrow: <img src={LeftArrow} />,
        nextArrow: <img src={RightArrow} />,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    const ShopByShapData = [
        {
            shape: "Round",
            image: Round,
            url: "/diamonds/Round",
        },
        {
            shape: "Princess",
            image: Princess,
            url: "/diamonds/Princess",
        },
        {
            shape: "Emerald",
            image: Emerald,
            url: "/diamonds/Emerald",
        },
        {
            shape: "Oval",
            image: Oval,
            url: "/diamonds/Oval",
        },
        {
            shape: "Radiant",
            image: Radiant,
            url: "/diamonds/Radiant",
        },
        {
            shape: "Asscher",
            image: Asscher,
            url: "/diamonds/Asscher",
        },
        {
            shape: "Marquise",
            image: Marquise,
            url: "/diamonds/Marquise",
        },
        {
            shape: "Heart",
            image: Heart,
            url: "/diamonds/Heart",
        },
        {
            shape: "Pear",
            image: Pear,
            url: "/diamonds/Pear",
        },
    ]


    return (
        <div className='dfl_eng_Shop_ring_by_style_section'>
            <Container className='dfl_custome_container_staticpage'>
                <Row>
                    <Col sm={12} md={12} lg={12}>
                        <div>
                            <div class="title-box2 text-center border-title mb-0">
                                <h2 class="title24 title-box2 dark">Shop By shape</h2>
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col sm={12} md={12} lg={12}>
                        <div className='dfld_shap_slider dfl___diamond_shap_slider'>
                            <Slider {...settingsShopByShape} className="dfld_explore_diamond_shap_slider">
                                {ShopByShapData.map((val, index) => (
                                    <NavLink className='dfld_img_shap_box_outer' to={val.url}>
                                        <div className='dfld_img_shap_box_inner dfl_eng_ring_img'>
                                            <Image src={val.image} alt={val.shape}/>
                                            <h4>{val.shape}</h4>
                                        </div>
                                    </NavLink>

                                ))}
                            </Slider>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default ShopByShap